import React, {useEffect, useState, useCallback} from "react";

// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";

import {quotationListCloseAction} from "../../features/sliceReducer/interactionReducer";

//import component
import SearchForm from "../../components/SearchForm";

//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import Loading from "../../components/Loading";
import {addCopiedCount, getQuotationList} from "../../features/sliceReducer/myProjectReducer";
import useCopyClipBoard from "../../customHook/useCopyClipBoard";
import QuotationFilter from "../../components/QuotationFilter";
import IPUtility from "../../classes/IPUtility";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1480px",
      minWidth: "1480px",
      height: "880px",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    table: {
      // minWidth: 650,
      border: "1px solid #dbdce0",
    },
    buttonCell: {
      display: "flex",
      alignItems: "center",

      width: "100%",
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: " 20px",
      "& form": {
        marginRight: "36px",
      },
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },

    buttonMargin: {
      // flex: "0 0 auto",
      // width: "80px",
      // height: "36px",
      marginRight: "18px",
    },
  })
);

const QuotationListModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const {quotationListModalToggle} = useSelector((state: RootState) => state.interaction);

  const {
    searchItemValues: SearchItemValues,
    loading,
    error,
    quotationFiltering,
    selectItem,
    quotationListTableHeader,
  } = useSelector((state: RootState) => state.myProject);

  const {userToken} = useSelector((state: RootState) => state.auth);

  const {preYear, type} = quotationFiltering;

  useEffect(() => {
    dispatch(getQuotationList({userToken, id: selectItem, searchWord, preYear, type}));
  }, [selectItem, searchWord, preYear, type]);

  // const searchDispatcher = useCallback(
  //   (page?: number, keyword?: string) => {
  //     if (page === undefined) page = 1;
  //     if (keyword === undefined)
  //       dispatch(getQuotationList({userToken, id: selectItem, searchWord}));
  //     else
  //       dispatch(
  //         getQuotationList({userToken, id: selectItem, searchWord: keyword})
  //       );
  //   },
  //   [searchWord]
  // );
  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (keyword === undefined)
      dispatch(getQuotationList({userToken, id: selectItem, searchWord, preYear, type}));
    else
      dispatch(
        getQuotationList({
          userToken,
          id: selectItem,
          searchWord: keyword,
          preYear,
          type,
        })
      );
  };

  const [isCopy, onCopy] = useCopyClipBoard();
  const handleCopyClipBoard = (text: string) => {
    onCopy(text);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={quotationListModalToggle}
      onClose={() => {
        dispatch(quotationListCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={quotationListModalToggle}>
        <TableContainer component={Paper} className={classes.paper}>
          {quotationListModalToggle || <Loading loading={loading} />}

          <Typography className={classes.modalTitle} variant="h5" component="h5">
            많이 인용된 아이템
          </Typography>
          <Box className={classes.searchInput}>
            <SearchForm
              setSearchWord={setSearchWord}
              page={page}
              searchDispatcher={searchDispatcher}
              searchWord={searchWord}
            />
            <QuotationFilter />
          </Box>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {quotationListTableHeader.map((headerTitle, index) => (
                  <TableCell key={index} align="center">
                    {headerTitle}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {SearchItemValues &&
                SearchItemValues.length > 0 &&
                SearchItemValues?.map((itemValue, index) => {
                  const typeLines = [] as string[];
                  const contentLines = [] as string[];
                  const quotationCount = [] as number[];
                  if (itemValue.general !== undefined && itemValue.general.length > 0) {
                    contentLines.push(itemValue.general);
                    quotationCount.push(itemValue.generalCopiedCount);
                    typeLines.push("일반");
                  }
                  if (itemValue.regulation !== undefined && itemValue.regulation.length > 0) {
                    contentLines.push(itemValue.regulation);
                    quotationCount.push(itemValue.regulationCopiedCount);
                    typeLines.push("법규");
                  }
                  if (
                    itemValue.recommendation !== undefined &&
                    itemValue.recommendation.length > 0
                  ) {
                    contentLines.push(itemValue.recommendation);
                    quotationCount.push(itemValue.recommendationCopiedCount);
                    typeLines.push("권고");
                  }
                  if (itemValue.instruction !== undefined && itemValue.instruction.length > 0) {
                    contentLines.push(itemValue.instruction);
                    quotationCount.push(itemValue.instructionCopiedCount);
                    typeLines.push("지침");
                  }
                  return typeLines.map((x, index2) => (
                    <StyledTableRow key={itemValue.uid + "-" + index2}>
                      <TableCell width="10%" align="center">
                        {typeLines[index2]}
                      </TableCell>
                      <TableCell width="80%" className={classes.buttonCell}>
                        <Button
                          className={classes.buttonMargin}
                          onClick={() => {
                            //IPUtility.copyString(contentLines[index2]);
                            handleCopyClipBoard(contentLines[index2]);
                            dispatch(addCopiedCount({userToken, id: itemValue.uid, type}));
                          }}
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<FileCopyIcon />}
                        ></Button>
                        <p>{contentLines[index2]}</p>
                      </TableCell>
                      <TableCell width="10%" align="center">
                        {quotationCount[index2]}
                      </TableCell>
                    </StyledTableRow>
                  ));
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Fade>
    </Modal>
  );
};

export default QuotationListModal;
